module.exports = __webpack_public_path__ + "img/w6_01.63f29053.jpg";